import React from "react";
import { Link } from "gatsby";
import logo from '../img/ipecore-logo.svg'

const Navbar = class extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      active: false,
      navBarActiveClass: ""
    };
  }

  toggleHamburger = () => {
    // toggle the active boolean in the state
    this.setState(
      {
        active: !this.state.active
      },
      // after state has been updated,
      () => {
        // set the class in state for the navbar accordingly
        this.state.active
          ? this.setState({
            navBarActiveClass: "is-active"
          })
          : this.setState({
            navBarActiveClass: ""
          });
      }
    );
  };

  render() {
    return (
      <nav
        className="navbar is-transparent is-fixed-top custom-box-shadow"
        role="navigation"
        aria-label="main-navigation"
      >
        <div className="container">
          <div className="navbar-brand">
            <Link to="/" className="navbar-item" title="Logo">
              <img
                src={logo}
                alt="ipecore"
                style={{ width: "120px" }}
              />
            </Link>
            {/* Hamburger menu */}
            <div
              className={`navbar-burger burger ${this.state.navBarActiveClass}`}
              data-target="navMenu"
              onClick={() => this.toggleHamburger()}
            >
              <span />
              <span />
              <span />
            </div>
          </div>
          <div
            id="navMenu"
            className={`navbar-menu ${this.state.navBarActiveClass}`}
          >
            <div className="navbar-start has-text-centered">
              <div className="navbar-item has-dropdown is-hoverable">
                <a className="navbar-link not-hoverable">Products</a>
                <div className="navbar-dropdown is-boxed">
                  <Link
                    className="navbar-item"
                    to="/products/l2-l3-managed-switch-core"
                  >
                    L2/L3 Managed Switch Core
                  </Link>
                  <hr className="navbar-divider" />
                  <Link
                    className="navbar-item"
                    to="/products/hsr-prp-redbox"
                  >
                    HSR/PRP RedBox 
                  </Link>
                  <hr className="navbar-divider" />
                  <Link
                    className="navbar-item"
                    to="/products/multi-gigabit-serdes-phy-pcie-gen4"
                  >
                     Multi-Gigabit SerDes PHY (PCIe Gen-4)  
                  </Link>
                </div>
              </div>

              <Link className="navbar-item" to="/technology">
                Technology
              </Link>
              <Link className="navbar-item" to="/about">
                About
              </Link>
              <Link className="navbar-item" to="/contact">
                Contact
              </Link>
            </div>
          </div>
        </div>
      </nav>
    );
  }
};

export default Navbar;
